// extracted by mini-css-extract-plugin
export default {"table":"Permissions_table__NVkrs"};